import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { LoggerService } from '../logger.service';
import { first } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private idToken: string | null = null;
  constructor(private auth: AngularFireAuth, private logger: LoggerService) {
    this.auth.idToken.subscribe((idToken) => (this.idToken = idToken));
  }

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return from(this.handle(req, next));
  }

  async handle(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Promise<HttpEvent<unknown>> {
    const token =
      this.idToken || (await this.auth.idToken.pipe(first()).toPromise());
    if (!token) return next.handle(req).toPromise();

    const authReq = req.clone({
      headers: req.headers.set('Authorization', `${token}`),
    });

    return next.handle(authReq).toPromise();
  }
}
